import React, { FunctionComponent } from 'react';

import { useVerticalConfig } from 'providers/vertical';

import { LivePersonMessagingProvider } from './LivePersonMessagingProvider';
import { PillowTalkWrapper } from './PillowTalkMessagingProvider';

interface Props {
  locale: string;
  marketCode: string;
}

const MessagingProviderWrapper: FunctionComponent<Props> = ({ locale, marketCode, children }) => {
  const { features } = useVerticalConfig();

  if (features?.configurePillowTalk) {
    return <PillowTalkWrapper locale={locale}>{children}</PillowTalkWrapper>;
  }

  return (
    <LivePersonMessagingProvider locale={locale} marketCode={marketCode}>
      {children}
    </LivePersonMessagingProvider>
  );
};

export default MessagingProviderWrapper;
